/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface GetLootBoxConfigsResponse
 */
export interface GetLootBoxConfigsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetLootBoxConfigsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<LootBoxConfigResponse>}
     * @memberof GetLootBoxConfigsResponse
     */
    lootBoxConfigs: Array<LootBoxConfigResponse>;
}

/**
 * Check if a given object implements the GetLootBoxConfigsResponse interface.
 */
export function instanceOfGetLootBoxConfigsResponse(value: object): value is GetLootBoxConfigsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('lootBoxConfigs' in value) || value['lootBoxConfigs'] === undefined) return false;
    return true;
}

export function GetLootBoxConfigsResponseFromJSON(json: any): GetLootBoxConfigsResponse {
    return GetLootBoxConfigsResponseFromJSONTyped(json, false);
}

export function GetLootBoxConfigsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLootBoxConfigsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'lootBoxConfigs': ((json['lootBoxConfigs'] as Array<any>).map(LootBoxConfigResponseFromJSON)),
    };
}

export function GetLootBoxConfigsResponseToJSON(json: any): GetLootBoxConfigsResponse {
    return GetLootBoxConfigsResponseToJSONTyped(json, false);
}

export function GetLootBoxConfigsResponseToJSONTyped(value?: GetLootBoxConfigsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'lootBoxConfigs': ((value['lootBoxConfigs'] as Array<any>).map(LootBoxConfigResponseToJSON)),
    };
}

